/* eslint-disable react/no-danger */
import React from 'react';

const DescModal = ({ prod, setMod }) => {
  const f = () => setMod(null);
  return (
    <div className={`Modal ${prod ? 'on' : 'off'}`}>
      <div className="button">
        <button type="button" onClick={f}>
          <i className="fas fa-times" />
        </button>
      </div>
      <div className="inner">
        {prod ? (
          <>
            <div className="img">
              <img src={`/public/uploads/${prod.product_img}`} alt="" />
            </div>
            <div className="text">
              <h1>{prod.pname}</h1>
              <div dangerouslySetInnerHTML={{ __html: prod.description }} />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default DescModal;
